import React from 'react';
const Audio = ({
  src
}: {
  src: string;
}) => {
  return <audio controls controlsList="nodownload">
      <source src={src} />
      This audio type is not supported: {src}
    </audio>;
};
export default Audio;